module.exports = __webpack_public_path__ + "static/media/logoDark.ce917e45.png";